import { render, staticRenderFns } from "./CookieWallSection.vue?vue&type=template&id=5466e984&scoped=true&"
import script from "./CookieWallSection.vue?vue&type=script&lang=ts&"
export * from "./CookieWallSection.vue?vue&type=script&lang=ts&"
import style0 from "./CookieWallSection.vue?vue&type=style&index=0&id=5466e984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466e984",
  null
  
)

export default component.exports